<template>
	<div>
		<!-- <com-back name="PSE"></com-back> -->
		<div class="wrapper" v-if="code == 0">
			<div style="position: relative;">
				<div class="top_title">Monto de pago</div>
				<!-- 1 or off  Display exemption labels
                    0 or on Do not display exemption labels -->
				<div
					class="bottom_title"
					v-if="dataTax.channelPaymentTaxSwith == 'on' && $route.query.reduction == 0"
					@click="handleBottomTitle(1)"
					:class="{ activeBottomTitle: activeBottomTitle == 1 }"
				>
					<input
						type="text"
						v-model="repayAmount"
						style="width:23%"
						@input="repayAmount = repayAmount.replace(/\D/g, '')"
					/>
					&nbsp;+&nbsp;
					<span style="color: #E52118">
						{{ addComma(dataTax.channelTaxAmount) }}
					</span>
					&nbsp; (Comisión)
				</div>
				<div v-else>
					<div
						class="bottom_title"
						@click="handleBottomTitle(1)"
						:class="{ activeBottomTitle: activeBottomTitle == 1 }"
					>
						<input type="text" v-model="repayAmount" style="width:20%" />
						&nbsp;+&nbsp;
						<span class="jianmian">
							{{ addComma(dataTax.channelTaxAmount) }}
						</span>
						&nbsp;
						<span style="color:#666666">(Comisión)</span>
					</div>
					<!-- <img src="@/assets/image/internal/payment/jianmian.png" alt="" class="jianmian_img" /> -->
				</div>
			</div>

			<div style="position: relative;">
				<div class="top_title">Banco</div>
				<div @click="handleSelect" class="bottom_title select" :class="{ activeBottomTitle: activeBottomTitle == 2 }">
					<span>{{ selectValue ? selectValue : 'Banco' }}</span>
					<img src="@/assets/image/internal/payment/up.webp" alt="" class="sanjiao_img" v-if="sanjiaoSelect" />
					<img src="@/assets/image/internal/payment/down.webp" alt="" class="sanjiao_img" v-else />
				</div>
				<ul v-show="selectShow">
					<div style="height: 4rem; overflow-y: auto;">
						<li
							v-for="item in jsonData"
							:key="item.id"
							@click="handleClick(item, item.id)"
							:style="{ background: item.id == optionIndex ? '#DEE2E7' : '' }"
						>
							<!-- <img src="@/assets/image/internal/payment/pse.png" class="pse_img" /> -->
							{{ item.description }}
						</li>
					</div>
				</ul>
			</div>
			<div style="margin-top: .3rem;">
				<div class="top_title">Nombre de proprietario de la cuenta</div>
				<input
					class="bottom_title"
					placeholder="Por favor ingrese el nombre correcto"
					v-model="inputParams.accountOwnerName"
					maxlength="60"
					@click="handleBottomTitle(3)"
					:class="{ activeBottomTitle: activeBottomTitle == 3 }"
				/>
			</div>
			<div>
				<div class="top_title">Número de identificación</div>
				<input
					class="bottom_title"
					placeholder="Por favor ingrese el número de identificación"
					v-model="inputParams.documentNuber"
					@input="handleInput('documentNuber', inputParams.documentNuber)"
					maxlength="30"
					@click="handleBottomTitle(4)"
					:class="{ activeBottomTitle: activeBottomTitle == 4 }"
				/>
			</div>
			<div>
				<div class="top_title">Número telefónico</div>
				<div class="bottom_title" @click="handleBottomTitle(5)" :class="{ activeBottomTitle: activeBottomTitle == 5 }">
					<span style="margin-right: .2rem;">+57</span>
					<input
						placeholder="Por favor ingrese el número telefónico"
						v-model="inputParams.phoneNumber"
						maxlength="10"
						@input="handleInput('phoneNumber', inputParams.phoneNumber)"
					/>
				</div>
			</div>
			<div class="redio" v-if="isShowRedio == 1">
				<div @click="changeRedio">
					<img src="@/assets/image/internal/select.webp" alt="" v-if="autoReloan == 1" />
					<img src="@/assets/image/internal/select_no.webp" v-else alt="" />
				</div>
				<span>Después de liquidar, obtener el nuevo límite y depositarlo directamente a mi cuenta bancaria</span>
			</div>
			<div class="redio_des">
				Para evitar retrasos en la obtención de tu nuevo crédito debido a los largos tiempos de procesamiento bancario,
				puedes marcar esta opción para obtener los fondos rápidamente. Garantizamos que la tarifa del nuevo préstamo no
				excederá la tarifa de préstamo actual y con un límite mayor.
			</div>
			<div class="bottom">
				<van-button @click="handleButton(optionIndex)"> CONFIRMAR ({{ total ? '$' + total : 0 }}) </van-button>
			</div>
		</div>
		<div class="no_wrapper" v-else>
			El enlace de pago ya está inválido, por favor contacte con nuestro Servicio al Cliente para obtener un nuevo.
		</div>
	</div>
</template>
<script>
	import common from '@/mixins/common.js'
	import jsonData from './bank.json'
	import { addComma, getQueryVariable } from '@/utils/internal'
	// import comBack from '@/components/internal/back.vue'
	export default {
		mixins: [common],
		data() {
			return {
				selectShow: false,
				selectValue: '',
				optionIndex: '',
				repayAmount: '',
				jsonData: {},
				code: '',
				dataTax: {},
				inputParams: {
					accountOwnerName: '',
					documentNuber: '',
					phoneNumber: '',
				},
				sanjiaoSelect: false,
				buttonDisabled: false,
				activeBottomTitle: null,
				// backShow: true,
				autoReloan: 0,
				isShowRedio: 0,
			}
		},
		components: {
			// comBack,
		},
		mounted() {
			this.jsonData = jsonData
			this.repayAmount = this.addComma(this.$route.query.repayAmount)
			document.title = this.$route.query.name
			this.getAccessToken()
			this.getApiHead()
			// window.android.hideTitle();
			this.getRepayTax()
			this.appStatisticsNew()
			this.getAutoReloan()
			window.callbackRiskToken = this.callbackRiskToken
		},
		computed: {
			total() {
				if (this.dataTax.channelPaymentTaxSwith == 'on') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')) + Number(this.dataTax.channelTaxAmount))
				} else if (this.dataTax.channelPaymentTaxSwith == 'off') {
					return this.addComma(Number(this.repayAmount.replace(/,/g, '')))
				} else return 0
			},
		},
		methods: {
			addComma,
			getQueryVariable,

			changeRedio() {
				if (this.autoReloan == 1) {
					this.autoReloan = 0
				} else {
					this.autoReloan = 1
				}
			},
			saveAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan/update', {
						...this.params,
						autoReloan: this.autoReloan,
					})
					.then(() => {})
			},
			getAutoReloan() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/autoReloan', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.autoReloan = res.data.data?.result
						}
					})
			},
			appStatisticsNew() {
				console.log('this.apiHeadGatewayVh---', this.apiHeadGatewayVh)
				this.$axios
					.post(this.apiHeadGatewayVh + 'auth/appsflyer/appStatisticsNew', {
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.isShowRedio = res.data.data?.repayPageShowAutoReloan
						}
					})
			},
			// Not allowed to input non numeric characters and display in 4 groups
			handleInput(name, value) {
				if (name == 'phoneNumber') {
					this.inputParams[name] = value.replace(/\D/g, '')
				} else {
					this.inputParams[name] = value.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ')
				}
			},
			//Add background color
			handleBottomTitle(value) {
				this.activeBottomTitle = value
				if (this.activeBottomTitle != 2) {
					this.selectShow = false
					this.sanjiaoSelect = false
				}
			},
			handleSelect() {
				this.selectShow = !this.selectShow
				this.sanjiaoSelect = !this.sanjiaoSelect
				this.handleBottomTitle(2)
			},
			//Click on the dropdown option
			handleClick(item, id) {
				this.optionIndex = id
				this.selectValue = item.description
				this.selectShow = false
			},

			//Cursor departure event
			handleBlur(repayAmount) {
				this.repayAmount = this.addComma(repayAmount.replace(/,/g, ''))
			},
			//Obtain handling fees
			getRepayTax() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'getRepayTax', {
						...this.params,
						paymentType: 'PSE',
						channelNo: this.getQueryVariable('channelNo'),
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.dataTax = JSON.parse(res.data.data)
							console.log(this.dataTax)
						}
					})
			},
			getRiskTokenByConfig() {
				let string = JSON.stringify({
					code: 3,
					smsFlag: 1,
					calendarFlag: 1,
					appListFlag: 1,
					reqPermission: 0,
					locationFlag: 1,
					trace: (Math.floor(Math.random() * 1000000) + 1).toString(),
				})
				window.android?.getRiskTokenByConfig(string)
			},
			callbackRiskToken(node, token, trace) {
				console.log('callbackRiskToken----pse----', node, token, trace)
				this.$axios
					.post(
						this.apiHeadGatewayVh + 'repay/record/create',
						{
							...this.params,
							tokenKey: token,
							orderId: this.getQueryVariable('orderId'),
							acctAmount: this.repayAmount.replace(/,/g, ''),
							bankCode: this.optionIndex,
							channelNo: this.getQueryVariable('channelNo'),
							paymentType: this.getQueryVariable('paymentType'),
							channelTaxAmount: this.dataTax.channelPaymentTaxSwith == 'on' ? this.dataTax.channelTaxAmount : 0,
							accountOwnerName: this.inputParams.accountOwnerName,
							documentNuber: this.inputParams.documentNuber.replace(/\s/g, ''),
							phoneNumber: this.inputParams.phoneNumber,
						},
						{ timeout: 60000 },
					)
					.then((res) => {
						this.code = res.data.code
						if (res.data.code == 0) {
							// this.backShow = false;
							// window.android.showTitle();
							window.open(res.data.data.token)
						}
						this.buttonDisabled = false
					})
			},
			//Button Jump
			handleButton(optionIndex) {
				if (Number(this.repayAmount.replace(/,/g, '')) < 10000) this.$toast('El pago mínimo: $10000')
				else if (optionIndex == '') this.$toast('Por favor elija el banco')
				else if (this.inputParams.accountOwnerName == '')
					this.$toast('Por favor ingrese el nombre de proprietario de la cuenta correcto')
				else if (this.inputParams.documentNuber == '') this.$toast('Por favor ingrese el número de C.C.ID correcto')
				else if (this.inputParams.phoneNumber == '') this.$toast('Por favor ingrese el número telefónico correcto')
				else {
					this.buttonDisabled = true
					if (this.isShowRedio) this.saveAutoReloan()
					this.getRiskTokenByConfig()
				}
			},
		},
	}
</script>
<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/pse.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
